export const versionInfo = (() => {
  try {
    // tslint:disable-next-line:no-var-requires
    return require('./VERSION.json');
  } catch {
    // In dev the file might not exist:
    return { tag: 'there is no VERSION.json file' };
  }
})();
